export const GET_ALL_BANNERS = "GET_ALL_BANNERS"
export const GET_ALL_BANNERS_RESPONSE_SUCCESS =
  "GET_ALL_BANNERS_RESPONSE_SUCCESS"
export const CREATE_BANNER = "CREATE_BANNER"
export const UPDATE_BANNER = "UPDATE_BANNER"
export const DELETE_BANNER = "DELETE_BANNER"
